<template>
  <div class="hero is-dark is-fullheight toc-grid">
    <div class="container is-widescreen">
      <div class="columns is-multiline is-mobile">
        <div class="column is-half-mobile is-one-third-tablet is-one-third-desktop"
             v-for="chapter in chapters">
          <router-link :to="'/chapter/' + chapter.id">
            <TocItem :chapter="chapter"></TocItem>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TocItem from '@/components/TocItem.vue'
export default {
  name: 'Toc',
  components: { TocItem },
  computed: {
    ...mapState(['chapters'])
  }
}
</script>

<style>
.toc-grid .container {
  padding: 1rem;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Toc.vue?07e9f5f0